module.exports = __webpack_public_path__ + "static/media/shopify-small.1651d42e.svg";